// extracted by mini-css-extract-plugin
module.exports = {"container":"ThePodVersusOtherSleepAids_container__6A5k0","table":"ThePodVersusOtherSleepAids_table__TmSvz","none":"ThePodVersusOtherSleepAids_none__5_S94"};